<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$root.dialogSettings.fullscreen"
    :scrollable="$root.dialogSettings.scrollable"
    :hide-overlay="$root.dialogSettings.hideoverlay"
    :transition="$root.dialogSettings.transition"
    :width="$root.dialogSettings.width"
    :max-width="$root.dialogSettings.maxwidth"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :class="classes"
        text
        v-on="on"
        @click.stop
      >
        {{ $t(text) }}
      </v-btn>
    </template>

    <v-card v-if="dialog">
      <v-card-title primary-title
                    class="text-h5 primary white--text justify-space-between">
        <span>{{ $t('viewContract') }}</span>
        <v-icon color="white"
                @click="dialog = false">
          fas fa-times-circle
        </v-icon>
      </v-card-title>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <pdf
              v-for="i in numPages"
              :id="i"
              :key="forceRenderKey + '-' + i"
              :src="pdfdata"
              :page="i"
              :scale.sync="scale"
              :annotation="true"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import pdf from 'pdfvuer'
  import 'pdfjs-dist/build/pdf.worker.entry'

  export default {
    props: {
      text: {
        type: String,
        default: 'viewContract',
        required: false
      },
      classes: {
        type: String,
        default: '',
        required: false
      }
    },
    components: {
      pdf
    },
    data: () => ({
      dialog: false,
      numPages: 0,
      pdfdata: undefined,
      scale: 'page-width',
      forceRenderKey: 0,
      pdflocale: 'fi'
    }),
    computed: {
      locale () {
        return this.$store.getters.locale
      }
    },
    watch: {
      dialog: function (active) {
        if (active) {
          this.getPdf()
        }
      }
    },
    methods: {
      getPdf () {
        if (this.pdfdata === undefined || this.pdflocale !== this.locale) {
          console.log(process.env.BASE_URL + 'terms_and_prices_' + this.locale + '.pdf')
          this.pdfdata = pdf.createLoadingTask(process.env.BASE_URL + 'terms_and_prices_' + this.locale + '.pdf')
          this.pdflocale = this.locale
          this.pdfdata.then(pdf => {
            this.numPages = pdf.numPages
            this.forceRenderKey++
          })
        }
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "viewContract": "Sopimusehdot ja hinnasto",
  "contractTerms": "sopimusehdot ja hinnasto"
  },
  "se": {
  "viewContract": "Avtalsvillkor och prislista",
  "contractTerms": "avtalsvillkoren och prislistan"
  },
  "en": {
  "viewContract": "Terms of service and price list",
  "contractTerms": "terms of service and price list"
  }
  }
</i18n>
